export default {
    delivery: {
        product: {
            tracking: "Követés",
            quantity: "Mennyiség"
        }
    }
}